require('bijou/base')

#== Description
# This widget adds simple CSS class toggling on a checkbox's label so that it
# can easily be styled when focused or checked.
#
# == Behaviour
# - toggles a 'checkbox-checked' CSS class on the label when the checkbox is
#   checked/unchecked
# - toggles a 'checkbox-focused' CSS class on the label when focus is set
#   on the checkbox
# - updates the label's initial checked state just in case the markup does not
#   reflect the current state of the input
# - updates the label's checked state when the question is made visible. This is
#   necessary as inputs are usually reset when hidden

"use strict"

$.widget "chopin.checkbox", $.bijou.base,
  _create: ->
    @label = @element.closest("label")

    @_on
      "change": @update,
      "disabledPartial": @disabledPartial,
      "focusin": ->
        @label.addClass("checkbox-focused")
      "focusout": ->
        @label.removeClass("checkbox-focused")

    @_on @element.closest(".control-block"),
      "questionShow": ->
        @update()
        @setHiddenFieldDisabledAttribute(false)


    @_on @element.closest(".control-block"),
      "questionHide": ->
        @setHiddenFieldDisabledAttribute('disabled')

    @update()

  update: ->
    @label.toggleClass("checkbox-checked", @element.prop("checked"))

  disabledPartial: ->
    disabledPartial = @element.closest("div")

    disabledPartial.toggleClass("disabled-partial")
    disabledPartial.closest(".product-selection-group__item").find(".--social-proofing").toggleClass("--is-disabled")

    if disabledPartial.hasClass("disabled-partial")
      disabledPartial.find(".product-selection-group__item-footer button").first().attr("tabindex", "-1")
    else
      disabledPartial.find(".product-selection-group__item-footer button").first().attr("tabindex", "0")

  setHiddenFieldDisabledAttribute: (state) ->
    @element.closest('.optional_hidden_field').prop('disabled', state)
